import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Typography} from "@material-ui/core";
import { ArrowDownward, ArrowUpward } from '@material-ui/icons';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import {IDataPartner} from "../../../types";


interface IProps {
    partnerData: IDataPartner
}

interface Istate {
}

interface IRowChart {
    name: string
    value: number
}

class UsuariosConfirmados extends React.Component<IProps, Istate> {

    state:Istate = {
    }

    // renderCustomizedLabel = (l: any) => {
    //     console.log(l)
    //     const RADIAN = Math.PI / 180;
    //     const radius = l.innerRadius + (l.outerRadius - l.innerRadius)/4
    //     const x = l.cx + radius * Math.cos(-l.midAngle * RADIAN)
    //     const y = l.cy + radius * Math.sin(-l.midAngle * RADIAN)
    //
    //     return (
    //         <text x={x} y={y} fill="black" textAnchor={x > l.cx ? 'start' : 'end'} dominantBaseline="central">
    //             {`${(l.percent * 100).toFixed(0)}`}
    //             {`${l.tooltipPayload[0].value}`}
    //         </text>
    //     )
    // }

    createDataChart = (): IRowChart[] => {
        let data = [
            {name: 'Básico', value: 0},
            {name: 'Avanzado', value: 0},
            {name: 'Profesional', value: 0},
            {name: 'Otro', value: 0}
        ] as IRowChart[]

        if (!this.props.partnerData.hasOwnProperty("users")) return data

        for (let user of this.props.partnerData.users) {
            if (user["confirmado"] === 0) continue

            if (user.level === 1) {
                data[0]["value"] += 1
            } else if (user.level === 2) {
                data[1]["value"] += 1
            } else if (user.level === 3) {
                data[2]["value"] += 1
            } else {
                data[3]["value"] += 1
            }
        }

        return data
    }

    newUsersProportion = (): number => {
        let thisMonthUsers = 0
        if (!this.props.partnerData.hasOwnProperty("users")) return thisMonthUsers
        let cnt = 0
        for (let user of this.props.partnerData.users) {
            if (user["confirmado"] === 0) continue
            cnt += 1
            let fechaCreacion = user["fecha_creacion"] as string
            let dateCreacion = new Date(fechaCreacion.split("-").reverse().join("/"))
            let dateThisMonth = new Date(`${new Date().getFullYear()}/${new Date().getMonth() + 1}/01`)
            if (dateCreacion >= dateThisMonth) thisMonthUsers += 1
        }
        return Math.round(1000*thisMonthUsers/cnt)/10
    }

    render() {
        const dataChart = this.createDataChart()

        const colors = ['#FF7777', '#694BDB', '#2BEBC8', '#f6d947'];

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "flex-start",
                    width: '100%',
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 20,
                    overflow: "auto"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: 30,
                        width: '100%',
                        marginTop: 20
                    }}
                >
                    <Typography
                        style={{
                            fontFamily: "Poppins",
                            marginLeft: 40,
                        }}
                    >
                        Usuarios confirmados
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        }}
                    >
                        {this.newUsersProportion() < 0 &&
                            <ArrowDownward style={{width: 15, height: 15, color: "red"}}/>
                        }
                        {this.newUsersProportion() > 0 &&
                            <ArrowUpward style={{width: 15, height: 15, color: "green"}}/>
                        }
                        {this.newUsersProportion() === 0 &&
                            <ArrowUpward style={{width: 15, height: 15, color: "grey"}}/>
                        }
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 10,
                                marginRight: 40,
                                fontSize: 12
                            }}
                        >
                            {this.newUsersProportion()} % respecto al mes anterior
                        </Typography>
                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 'calc(100% - 40px)',
                        height: 'calc(100% - 70px)'
                    }}
                >

                    <div
                        style={{
                            width: '60%',
                            height: '100%'
                        }}
                    >
                        <ResponsiveContainer
                            width="100%"
                            height="100%"
                        >
                            <PieChart
                                margin={{
                                    top: 30,
                                    right: 30,
                                    left: 30,
                                    bottom: 30,
                                }}
                            >
                                <Pie
                                    data={dataChart}
                                    dataKey="value"
                                    cx="50%"
                                    cy="50%"
                                    label
                                    // label={(l) => this.renderCustomizedLabel(l)}
                                    innerRadius={50}
                                    outerRadius={90}
                                >
                                    {dataChart.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            width: '40%',
                            height: 'calc(100% - 40px)'
                        }}
                    >
                        {dataChart.map((value, index) =>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 20,
                                    marginBottom: 10
                                }}
                                key={index}
                            >
                                <div style={{width: 20, height: 20, borderRadius: 5, backgroundColor: colors[index]}}/>
                                <Typography
                                    style={{
                                        marginLeft: 10,
                                        fontFamily: "Poppins",
                                        color: colors[index]
                                    }}
                                >
                                    {value.name}
                                </Typography>
                            </div>
                        )}

                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    partnerData: state.partner.dataPartner
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(UsuariosConfirmados);
